/**
 * Backend de tradução do i18next baseado em import() dinâmico do Vite.
 *
 * Cada namespace vira um chunk separado: o bundle inicial não carrega as chaves de
 * todos os idiomas, só as do idioma ativo são baixadas (todas na inicialização,
 * ver src/i18n/index.js).
 *
 * Não usa i18next-http-backend de propósito: buscar JSON por HTTP exigiria
 * liberar o host na CSP estrita do vercel.json e criaria uma dependência de rede
 * para a interface renderizar.
 */

// O glob é resolvido em build time; o import() de cada arquivo, em runtime.
const carregadores = import.meta.glob('./locales/*/*.json');

function chaveDoArquivo(idioma, namespace) {
    return `./locales/${idioma}/${namespace}.json`;
}

/** Namespaces disponíveis para um idioma (o init do i18next carrega todos). */
export function namespacesDisponiveis(idioma) {
    const prefixo = `./locales/${idioma}/`;

    return Object.keys(carregadores)
        .filter((caminho) => caminho.startsWith(prefixo))
        .map((caminho) => caminho.slice(prefixo.length).replace(/\.json$/, ''));
}

const backendDeTraducao = {
    type: 'backend',

    init() {},

    read(idioma, namespace, callback) {
        const carregador = carregadores[chaveDoArquivo(idioma, namespace)];

        if (!carregador) {
            // Namespace ainda não existe neste idioma. Não é erro: o i18next cai
            // no fallbackLng e a tela mostra o texto em português.
            callback(null, {});
            return;
        }

        carregador()
            .then((modulo) => callback(null, modulo.default))
            .catch((erro) => callback(erro, null));
    },
};

export default backendDeTraducao;
